module.exports = __webpack_public_path__ + "static/img/advantage3.b6b7136b.png";